module.exports = __webpack_public_path__ + "static/media/shoe.c07cdb9b.gif";